const activeFeatures = (query) => {
  return (query && query.features && query.features.split(',')) || []
}

export default activeFeatures



// WEBPACK FOOTER //
// ./common/utils/activeFeatures.js